import { connect } from 'react-redux';

import {
    fetchPolicyAction,
    policiesSelectors,
} from 'wanderu-ducks-carriers';
import {
    tripSelectors,
} from 'wanderu-ducks-trips';

import { CarrierPolicies } from './CarrierPolicies';

const mapStateToProps = (state, ownProps) => {
    const codes = ownProps?.tripIds?.map((id) => {
        const trip = tripSelectors.selectTrip(state, id);

        return trip?.carrierCode;
    });
    // this is to make sure that the array contains only unique values
    const s = new Set(codes);
    const carrierCodes = [...s];

    const carrierPolicies = policiesSelectors.selectPolicies(state, carrierCodes);

    return {
        carrierCodes,
        carrierPolicies,
    };
};

const mapDispatchToProps = {
    fetchPolicy: fetchPolicyAction.fetchPolicy,
};

export {
    CarrierPolicies,
};

export default connect(mapStateToProps, mapDispatchToProps)(CarrierPolicies);
